<template>
  <Walkthrough 
    roomName="Garage"
    roomKey="garage"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="italian"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/garage-1920x1280.jpg",
    steps: [
        "Guarda a destra e ispeziona le mensole dove dovresti trovare un panno e un secchio. ",
        "Guarda a sinistra e ispeziona la motocicletta. Noterai che sta perdendo, quindi puoi raccogliere un po' dell'olio per alimentare il generatore. ",
        "Mentre guardi a sinistra, usa il secchio sulla motocicletta per riempirlo. ",
        "Guarda  a destra e usa il secchio sul generatore. Poi, prova ad utilizzare il generatore. ",
        "Senza la cordicella, il generatore non patirà. Usa la corda sul generatore come funicella improvvisata. Il generatore dovrebbe partire e portare dell'energia alla stanza. ",
        "Guarda davanti e usa il panno sulla porta del garage per pulire le finestre. Comprenderai che sei a via HIDE. Questo dovrebbe aiutarti con la cassetta degli attrezzi. ",
        "Guarda giù e ispeziona la cassetta degli attrezzi. ",
        "Inserisci il codice 8 - 9 - 4 - 5 (H I D E). La cassetta degli attrezzi dovrebbe aprirsi e dentro troverai del lubrificante. ",
        "Guarda a destra, ispeziona le mensole, e ispeziona il lettore di cassette. Dovresti sentire del codice morse. Questo è il codice per l'interruttore! ",
        "Guarda a sinistra, e ispeziona l'interruttore. ",
        "Collega i cavi ROSSO, BIANCO, BLU, VERDE, e dovrebbe tornare l'elettricità nella stanza.",
        "Guarda su e usa il lubrificante sul meccanismo di apertura del garage per faro operare correttamente.",
        "Infine, guarda davanti, e utilizza il tasto per aprire la porta del garage e SCAPPARE!"
    ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/it/garage.vue